/**
 * Error 타입 가드
 */
export const isError = (error: unknown): error is Error => {
  return error instanceof Error;
};

/**
 * message 속성을 가진 에러인지 확인
 */
export const isErrorWithMessage = (
  error: unknown,
): error is { message: string } => {
  return (
    !!error &&
    typeof error === 'object' &&
    'message' in error &&
    typeof error.message === 'string'
  );
};

/**
 * stack 속성을 가진 에러인지 확인
 */
export const isErrorWithStack = (
  error: unknown,
): error is { stack: string } => {
  return (
    !!error &&
    typeof error === 'object' &&
    'stack' in error &&
    typeof error.stack === 'string'
  );
};
